// extracted by mini-css-extract-plugin
export default {"profile_buttons":"profilePage_profile_buttons__yv97j","documents":"profilePage_documents__AgjYL"};